module.exports = __webpack_public_path__ + "files/f0fdb80897cbc4e4f5ce206ad9bff263.png";